// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { Container } from '@crehana/ui';
import Loadable from '@crehana/web/Loadable';

import DashboardErrorView from '@/views/UserDashboard/components/DashboardTemplate/DashboardErrorView';

import DegreeSkeleton from './components/DegreeSkeleton';

const LazyDegrees = () => (
  <Loadable
    Loader={
      <Container type="dashboard">
        <DegreeSkeleton />
      </Container>
    }
    ErrorFallback={
      <Container type="dashboard">
        <DashboardErrorView defaultConnectionError supportsDarkMode />
      </Container>
    }
    module={() =>
      import(/* webpackChunkName: "user-dashboard-degrees" */ './Degrees')
    }
  />
);
export default LazyDegrees;
